/**
 * On track bucket icon: teal check mark inside a rounded badge. Colors are fixed in the SVG.
 */
import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconBucketOnTrack: React.FC<IconProps> = (): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="15.8421" height="15" rx="7.5" fill="#E9FAF8" stroke="#1BC1B0" />
            <path
                d="M12.9941 5.14453L6.58691 11.9082L3.86523 9.32324L4.55469 8.59863L6.54883 10.4932L12.2676 4.45703L12.9941 5.14453Z"
                fill="#1BC1B0"
                stroke="#1BC1B0"
                strokeWidth="0.5"
            />
        </svg>
    </div>
);

export default IconBucketOnTrack;
